/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import Banner from 'common/components/banner/banner';
// eslint-disable-next-line no-restricted-imports
import { forNamespace } from 'common/lib/util/i18n';
import * as React from 'react';

import styles from './small-team-boards-cta-banner.less';

interface SmallCtaProps {
  teamName: string;
  teamBoardsLink: string;
  onDismiss: () => void;
  onClickLink?: React.EventHandler<React.MouseEvent<HTMLElement>>;
}

const SmallBanner = (props: SmallCtaProps) => {
  const format = forNamespace('board section banner');

  return (
    <Banner onDismiss={props.onDismiss} inlinePadding roundedCorners>
      {
        <div className={styles.smallTeamBoardsBanner}>
          👀
          {format('access to lots of boards', {
            teamName: props.teamName,
          })}{' '}
          <a href={props.teamBoardsLink} onClick={props.onClickLink}>
            {format('check them out')}
          </a>
        </div>
      }
    </Banner>
  );
};

export default SmallBanner;



// WEBPACK FOOTER //
// ./app/scripts/views/member/team-boards-cta/small-team-boards-cta-banner.tsx